
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// // import "jspdf-autotable"; // Important for PDF table export
// import autoTable from "jspdf-autotable";  // default import

// import "../assets/GroupLoanReport.css";

// const EmiDueReportGroup = () => {
//   const [filter, setFilter] = useState({ status: "", frequency: "", centre: "" });
//   const [emiData, setEmiData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // 🔹 Fetch EMI Report
//   useEffect(() => {
//     const fetchEmis = async () => {
//       try {
//         const res = await axios.get(
//           `https://payyug.in/api/group-loan/emi-du?superAdminId=${localStorage.getItem('adminuserId')}`
//         );
//         if (res.data.success) {
//           setEmiData(res.data.data);
//         }
//       } catch (err) {
//         console.error("Error fetching EMI report:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchEmis();
//   }, []);

//   // 🔹 Transform backend data for frontend display
//   const transformedData = emiData.map((row) => ({
//     id: row.id,
//     loanId: row.groupLoanId,
//     memberName: row.memberId, // you can join with Member API if needed
//     groupName: row.centreName,
//     dueDate: row.dueDate,
//     principal: row.principalComponent || 0,
//     interest: row.interestComponent || 0,
//     totalEmi: row.total,
//     paidAmount: row.paid ? row.total : 0,
//     status: row.paid ? "Paid" : new Date(row.dueDate) < new Date() ? "Overdue" : "Pending",
//     frequency: "N/A" // Replace if available in API
//   }));

//   // 🔹 Apply filters
//   const filteredData = transformedData.filter((row) => {
//     return (
//       (filter.status ? row.status === filter.status : true) &&
//       (filter.frequency ? row.frequency === filter.frequency : true) &&
//       (filter.centre ? row.groupName === filter.centre : true)
//     );
//   });

//   // 🔹 Unique Centres for Dropdown
//   const centres = [...new Set(transformedData.map((row) => row.groupName))];

//   // 🔹 Export CSV
//   const exportCSV = () => {
//     const csvRows = [];
//     const headers = [
//       "Loan ID",
//       "Member",
//       "Centre",
//       "Due Date",
//       "Principal",
//       "Interest",
//       "Total EMI",
//       "Paid Amount",
//       "Status",
//       "Frequency",
//     ];
//     csvRows.push(headers.join(","));
//     filteredData.forEach((row) => {
//       const values = [
//         row.loanId,
//         row.memberName,
//         row.groupName,
//         new Date(row.dueDate).toLocaleDateString(),
//         row.principal,
//         row.interest,
//         row.totalEmi,
//         row.paidAmount,
//         row.status,
//         row.frequency,
//       ];
//       csvRows.push(values.join(","));
//     });
//     const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
//     saveAs(blob, "emi_due_report.csv");
//   };

//   // 🔹 Export Excel
//   const exportExcel = () => {
//     const ws = XLSX.utils.json_to_sheet(filteredData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "EMI Report");
//     XLSX.writeFile(wb, "emi_due_report.xlsx");
//   };



// const exportPDF = () => {
//   const doc = new jsPDF("l", "pt", "a4"); // landscape, points, A4

//   // 🔹 Header
//   doc.setFontSize(14);
//   doc.text("Subh Credit Co-Operative Society Limited", 40, 40);
//   doc.setFontSize(12);
//   doc.text("Collection Demand Sheet", 40, 60);

//   // 🔹 Info Row (Branch, Region, Phone, etc.)
//   autoTable(doc, {
//     startY: 70,
//     theme: "grid",
//     styles: { halign: "center", fontSize: 9 },
//     body: [
//       [
//         { content: "Branch: INDORE", colSpan: 2 },
//         "193-01",
//         { content: "Region: INDORE", colSpan: 2 },
//         "Ph No: 9907051434",
//       ],
//     ],
//   });

//   // 🔹 Main Table
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 10,
//     theme: "grid",
//     styles: { fontSize: 8, halign: "center" },
//     head: [[
//       "FO NAME", "CENTER NO", "DOB", "VILLAGE NAME", "MEMBER NAME & NO",
//       "HUSBAND NAME", "MOBILE NO", "OUTSTANDING", "EMI NO", "COLL. DATE",
//       "DISBURSEMENT AMT", "TODAY'S DEMAND", "SHARE/ RD AMT", "TOTAL EMI AMT",
//       "TOTAL COLL. CASH", "FD BOND NO", "MEMBER SIGN", "ATTENDANCE"
//     ]],
//     body: filteredData.map((row) => [
//       row.foName,
//       row.centerNo,
//       row.dob,
//       row.village,
//       row.memberName + " " + row.memberNo,
//       row.husbandName,
//       row.mobile,
//       row.outstanding,
//       row.emiNo,
//       row.collectionDate,
//       row.disbursementAmount,
//       row.todaysDemand,
//       row.shareAmount,
//       row.totalEmi,
//       row.totalCollection,
//       row.fdBondNo,
//       "",
//       "",
//     ]),
//   });

//   // 🔹 Grand Total Row
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 10,
//     theme: "grid",
//     styles: { fontSize: 9, halign: "center" },
//     body: [["GRAND TOTAL", "", "", "", "", "", "", "80000", "", "", "", "6877", "", "193", "7070"]],
//   });

//   // 🔹 Cash Denomination Table
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 20,
//     theme: "grid",
//     styles: { fontSize: 9, halign: "center" },
//     head: [["2000x", "500x", "200x", "100x", "50x", "20x", "10x", "5x", "Coin", "TOTAL"]],
//     body: [["", "", "", "", "", "", "", "", "", ""]],
//   });

//   // 🔹 Online Transaction Details
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 20,
//     theme: "grid",
//     styles: { fontSize: 9, halign: "center" },
//     head: [["Mode of Pay", "Transaction ID", "Amount", "Mode of Pay", "Transaction ID", "Amount"]],
//     body: [["", "", "", "", "", ""]],
//   });

//   // 🔹 FO Comments
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 20,
//     theme: "plain",
//     styles: { fontSize: 9 },
//     body: [["FO Comments:"]],
//   });

//   // 🔹 Signature Rows
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 20,
//     theme: "plain",
//     styles: { fontSize: 9, halign: "center" },
//     body: [[
//       "Signature of Center Leader",
//       "Signature of FO",
//       "Signature of BM/AM",
//       "Signature of Cashier",
//     ]],
//   });

//   doc.save("collection_demand_sheet.pdf");
// };


//   return (
//     <div className="emi-report-container">
//       <div className="emi-report-header">
//         <h2>
//           <i className="bi bi-file-earmark-text"></i> EMI Due Report
//         </h2>

//         {/* 🔹 Filters */}
//         <div className="emi-report-filters">
//           <select
//             value={filter.status}
//             onChange={(e) => setFilter({ ...filter, status: e.target.value })}
//           >
//             <option value="">All Status</option>
//             <option value="Pending">Pending</option>
//             <option value="Paid">Paid</option>
//             <option value="Overdue">Overdue</option>
//           </select>

//           <select
//             value={filter.frequency}
//             onChange={(e) => setFilter({ ...filter, frequency: e.target.value })}
//           >
//             <option value="">All Frequency</option>
//             <option value="weekly">Weekly</option>
//             <option value="monthly">Monthly</option>
//           </select>

//           <select
//             value={filter.centre}
//             onChange={(e) => setFilter({ ...filter, centre: e.target.value })}
//           >
//             <option value="">All Centres</option>
//             {centres.map((c, idx) => (
//               <option key={idx} value={c}>
//                 {c}
//               </option>
//             ))}
//           </select>

//           {/* 🔹 Export Buttons */}
//           {/* <button onClick={exportCSV} className="btn-export">CSV</button> */}
//           <button onClick={exportExcel} className="btn-export">Download</button>
//           {/* <button onClick={exportPDF} className="btn-export">PDF</button> */}
//         </div>
//       </div>

//       {/* 🔹 EMI Due Table */}
//       {loading ? (
//         <p>Loading EMI report...</p>
//       ) : (
//         <table className="emi-report-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Loan ID</th>
//               <th>Member</th>
//               <th>Centre</th>
//               <th>Due Date</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Total EMI</th>
//               <th>Paid Amount</th>
//               <th>Status</th>
//               <th>Frequency</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredData.length > 0 ? (
//               filteredData.map((row, idx) => (
//                 <tr key={row.id}>
//                   <td>{idx + 1}</td>
//                   <td>{row.loanId}</td>
//                   <td>{row.memberName}</td>
//                   <td>{row.groupName}</td>
//                   <td>{new Date(row.dueDate).toLocaleDateString()}</td>
//                   <td>₹{row.principal}</td>
//                   <td>₹{row.interest}</td>
//                   <td>₹{row.totalEmi}</td>
//                   <td>₹{row.paidAmount}</td>
//                   <td
//                     className={
//                       row.status === "Paid"
//                         ? "status-paid"
//                         : row.status === "Pending"
//                         ? "status-pending"
//                         : "status-overdue"
//                     }
//                   >
//                     {row.status}
//                   </td>
//                   <td>{row.frequency}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" className="text-center">
//                   No records found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default EmiDueReportGroup;





// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// // import "jspdf-autotable"; // Important for PDF table export
// import autoTable from "jspdf-autotable";  // default import

// import "../assets/css/EmiDueReport.css";

// const EmiDueReportGroup = () => {
//   const [filter, setFilter] = useState({ status: "", frequency: "", centre: "" });
//   const [emiData, setEmiData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // 🔹 Fetch EMI Report
//   useEffect(() => {
//     const fetchEmis = async () => {
//       try {
//         const res = await axios.get(
//           `https://payyug.in/api/group-loan/last-emidue-report?branchId=${localStorage.getItem("userId")}`
//         );
//         if (res.data.success) {
//           setEmiData(res.data.data);
//         }
//       } catch (err) {
//         console.error("Error fetching EMI report:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchEmis();
//   }, []);

//   // 🔹 Transform backend data for frontend display
//   const transformedData = emiData.map((row) => ({
//     id: row.id,
//     loanId: row.groupLoanId,
//     memberName: row.memberId, // you can join with Member API if needed
//     groupName: row.centreName,
//     dueDate: row.dueDate,
//     principal: row.principalComponent || 0,
//     interest: row.interestComponent || 0,
//     totalEmi: row.total,
//     paidAmount: row.paid ? row.total : 0,
//     status: row.paid ? "Paid" : new Date(row.dueDate) < new Date() ? "Overdue" : "Pending",
//     frequency: "N/A" // Replace if available in API
//   }));

//   // 🔹 Apply filters
//   const filteredData = transformedData.filter((row) => {
//     return (
//       (filter.status ? row.status === filter.status : true) &&
//       (filter.frequency ? row.frequency === filter.frequency : true) &&
//       (filter.centre ? row.groupName === filter.centre : true)
//     );
//   });

//   // 🔹 Unique Centres for Dropdown
//   const centres = [...new Set(transformedData.map((row) => row.groupName))];

//   // 🔹 Export CSV
//   const exportCSV = () => {
//     const csvRows = [];
//     const headers = [
//       "Loan ID",
//       "Member",
//       "Centre",
//       "Due Date",
//       "Principal",
//       "Interest",
//       "Total EMI",
//       "Paid Amount",
//       "Status",
//       "Frequency",
//     ];
//     csvRows.push(headers.join(","));
//     filteredData.forEach((row) => {
//       const values = [
//         row.loanId,
//         row.memberName,
//         row.groupName,
//         new Date(row.dueDate).toLocaleDateString(),
//         row.principal,
//         row.interest,
//         row.totalEmi,
//         row.paidAmount,
//         row.status,
//         row.frequency,
//       ];
//       csvRows.push(values.join(","));
//     });
//     const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
//     saveAs(blob, "emi_due_report.csv");
//   };

//   // 🔹 Export Excel
//   const exportExcel = () => {
//     const ws = XLSX.utils.json_to_sheet(filteredData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "EMI Report");
//     XLSX.writeFile(wb, "emi_due_report.xlsx");
//   };

// //   const exportPDF = () => {
// //   const doc = new jsPDF();
// //   doc.text("EMI Due Report", 14, 10);

// //   autoTable(doc, {
// //     startY: 20,
// //     head: [[
// //       "Loan ID", "Member", "Centre", "Due Date", 
// //       "Principal", "Interest", "Total EMI", 
// //       "Paid Amount", "Status", "Frequency"
// //     ]],
// //     body: filteredData.map((row) => [
// //       row.loanId,
// //       row.memberName,
// //       row.groupName,
// //       new Date(row.dueDate).toLocaleDateString(),
// //       row.principal,
// //       row.interest,
// //       row.totalEmi,
// //       row.paidAmount,
// //       row.status,
// //       row.frequency,
// //     ]),
// //   });

// //   doc.save("emi_due_report.pdf");
// // };


// const exportPDF = () => {
//   const doc = new jsPDF("l", "pt", "a4"); // landscape, points, A4

//   // 🔹 Header
//   doc.setFontSize(14);
//   doc.text("Subh Credit Co-Operative Society Limited", 40, 40);
//   doc.setFontSize(12);
//   doc.text("Collection Demand Sheet", 40, 60);

//   // 🔹 Info Row (Branch, Region, Phone, etc.)
//   autoTable(doc, {
//     startY: 70,
//     theme: "grid",
//     styles: { halign: "center", fontSize: 9 },
//     body: [
//       [
//         { content: "Branch: INDORE", colSpan: 2 },
//         "193-01",
//         { content: "Region: INDORE", colSpan: 2 },
//         "Ph No: 9907051434",
//       ],
//     ],
//   });

//   // 🔹 Main Table
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 10,
//     theme: "grid",
//     styles: { fontSize: 8, halign: "center" },
//     head: [[
//       "FO NAME", "CENTER NO", "DOB", "VILLAGE NAME", "MEMBER NAME & NO",
//       "HUSBAND NAME", "MOBILE NO", "OUTSTANDING", "EMI NO", "COLL. DATE",
//       "DISBURSEMENT AMT", "TODAY'S DEMAND", "SHARE/ RD AMT", "TOTAL EMI AMT",
//       "TOTAL COLL. CASH", "FD BOND NO", "MEMBER SIGN", "ATTENDANCE"
//     ]],
//     body: filteredData.map((row) => [
//       row.foName,
//       row.centerNo,
//       row.dob,
//       row.village,
//       row.memberName + " " + row.memberNo,
//       row.husbandName,
//       row.mobile,
//       row.outstanding,
//       row.emiNo,
//       row.collectionDate,
//       row.disbursementAmount,
//       row.todaysDemand,
//       row.shareAmount,
//       row.totalEmi,
//       row.totalCollection,
//       row.fdBondNo,
//       "",
//       "",
//     ]),
//   });

//   // 🔹 Grand Total Row
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 10,
//     theme: "grid",
//     styles: { fontSize: 9, halign: "center" },
//     body: [["GRAND TOTAL", "", "", "", "", "", "", "80000", "", "", "", "6877", "", "193", "7070"]],
//   });

//   // 🔹 Cash Denomination Table
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 20,
//     theme: "grid",
//     styles: { fontSize: 9, halign: "center" },
//     head: [["2000x", "500x", "200x", "100x", "50x", "20x", "10x", "5x", "Coin", "TOTAL"]],
//     body: [["", "", "", "", "", "", "", "", "", ""]],
//   });

//   // 🔹 Online Transaction Details
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 20,
//     theme: "grid",
//     styles: { fontSize: 9, halign: "center" },
//     head: [["Mode of Pay", "Transaction ID", "Amount", "Mode of Pay", "Transaction ID", "Amount"]],
//     body: [["", "", "", "", "", ""]],
//   });

//   // 🔹 FO Comments
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 20,
//     theme: "plain",
//     styles: { fontSize: 9 },
//     body: [["FO Comments:"]],
//   });

//   // 🔹 Signature Rows
//   autoTable(doc, {
//     startY: doc.lastAutoTable.finalY + 20,
//     theme: "plain",
//     styles: { fontSize: 9, halign: "center" },
//     body: [[
//       "Signature of Center Leader",
//       "Signature of FO",
//       "Signature of BM/AM",
//       "Signature of Cashier",
//     ]],
//   });

//   doc.save("collection_demand_sheet.pdf");
// };


//   return (
//     <div className="emi-report-container">
//       <div className="emi-report-header">
//         <h2>
//           <i className="bi bi-file-earmark-text"></i> EMI Due Report
//         </h2>

//         {/* 🔹 Filters */}
//         <div className="emi-report-filters">
//           <select
//             value={filter.status}
//             onChange={(e) => setFilter({ ...filter, status: e.target.value })}
//           >
//             <option value="">All Status</option>
//             <option value="Pending">Pending</option>
//             <option value="Paid">Paid</option>
//             <option value="Overdue">Overdue</option>
//           </select>

//           <select
//             value={filter.frequency}
//             onChange={(e) => setFilter({ ...filter, frequency: e.target.value })}
//           >
//             <option value="">All Frequency</option>
//             <option value="weekly">Weekly</option>
//             <option value="monthly">Monthly</option>
//           </select>

//           <select
//             value={filter.centre}
//             onChange={(e) => setFilter({ ...filter, centre: e.target.value })}
//           >
//             <option value="">All Centres</option>
//             {centres.map((c, idx) => (
//               <option key={idx} value={c}>
//                 {c}
//               </option>
//             ))}
//           </select>

//           {/* 🔹 Export Buttons */}
//           <button onClick={exportCSV} className="btn-export">CSV</button>
//           <button onClick={exportExcel} className="btn-export">Excel</button>
//           <button onClick={exportPDF} className="btn-export">PDF</button>
//         </div>
//       </div>

//       {/* 🔹 EMI Due Table */}
//       {loading ? (
//         <p>Loading EMI report...</p>
//       ) : (
//         <table className="emi-report-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Loan ID</th>
//               <th>Member</th>
//               <th>Centre</th>
//               <th>Due Date</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Total EMI</th>
//               <th>Paid Amount</th>
//               <th>Status</th>
//               <th>Frequency</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredData.length > 0 ? (
//               filteredData.map((row, idx) => (
//                 <tr key={row.id}>
//                   <td>{idx + 1}</td>
//                   <td>{row.loanId}</td>
//                   <td>{row.memberName}</td>
//                   <td>{row.groupName}</td>
//                   <td>{new Date(row.dueDate).toLocaleDateString()}</td>
//                   <td>₹{row.principal}</td>
//                   <td>₹{row.interest}</td>
//                   <td>₹{row.totalEmi}</td>
//                   <td>₹{row.paidAmount}</td>
//                   <td
//                     className={
//                       row.status === "Paid"
//                         ? "status-paid"
//                         : row.status === "Pending"
//                         ? "status-pending"
//                         : "status-overdue"
//                     }
//                   >
//                     {row.status}
//                   </td>
//                   <td>{row.frequency}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" className="text-center">
//                   No records found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default EmiDueReportGroup;




// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// import "../css/EmiDueReport.css";

// const EmiDueReportGroup = () => {
//   const [filter, setFilter] = useState({ status: "", frequency: "", centre: "" });
//   const [emiData, setEmiData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // 🔹 Fetch EMI Report
//   useEffect(() => {
//     const fetchEmis = async () => {
//       try {
//         const branchId = localStorage.getItem("userId");   // store correct IDs

//         const res = await axios.get(
//           `https://payyug.in/api/group-loan/last-emidue-report?superAdminId=${localStorage.getItem('adminuserId')}`
//         );

//         if (res.data.success) {
//           setEmiData(res.data.lastUpcomingEmis || []);
//         }
//       } catch (err) {
//         console.error("Error fetching EMI report:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchEmis();
//   }, []);

//   // 🔹 Transform backend data for frontend display
//   const transformedData = emiData.map((row) => ({
//     id: row.id,
//     loanId: row.groupLoanId,
//     loanAccountNumber: row.loanAccountNumber,
//     memberId: row.memberId,
//     groupName: row.centreName,
//     dueDate: row.dueDate,
//     principal: row.principalComponent || 0,
//     interest: row.interestComponent || 0,
//     totalEmi: row.total,
//     paidAmount: row.paidAmount || 0,
//     status: row.paid ? "Paid" : new Date(row.dueDate) < new Date() ? "Overdue" : "Pending",
//     frequency: "N/A" // if not in API
//   }));

//   // 🔹 Apply filters
//   const filteredData = transformedData.filter((row) => {
//     return (
//       (filter.status ? row.status === filter.status : true) &&
//       (filter.frequency ? row.frequency === filter.frequency : true) &&
//       (filter.centre ? row.groupName === filter.centre : true)
//     );
//   });

//   // 🔹 Unique Centres for Dropdown
//   const centres = [...new Set(transformedData.map((row) => row.groupName))];

//   // 🔹 Export CSV
//   const exportCSV = () => {
//     const headers = [
//       "Loan ID",
//       "Loan Account No",
//       "Member",
//       "Centre",
//       "Due Date",
//       "Principal",
//       "Interest",
//       "Total EMI",
//       "Paid Amount",
//       "Status",
//       "Frequency",
//     ];
//     const rows = filteredData.map((row) => [
//       row.loanId,
//       row.loanAccountNumber,
//       row.memberId,
//       row.groupName,
//       new Date(row.dueDate).toLocaleDateString(),
//       row.principal,
//       row.interest,
//       row.totalEmi,
//       row.paidAmount,
//       row.status,
//       row.frequency,
//     ]);
//     const csvContent = [headers, ...rows].map((r) => r.join(",")).join("\n");
//     saveAs(new Blob([csvContent], { type: "text/csv;charset=utf-8;" }), "emi_due_report.csv");
//   };

//   // 🔹 Export Excel
//   const exportExcel = () => {
//     const ws = XLSX.utils.json_to_sheet(filteredData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "EMI Report");
//     XLSX.writeFile(wb, "emi_due_report.xlsx");
//   };

//   // 🔹 Export PDF
//   const exportPDF = () => {
//     const doc = new jsPDF("l", "pt", "a4");
//     doc.setFontSize(14);
//     doc.text("Subh Credit Co-Operative Society Limited", 40, 40);
//     doc.setFontSize(12);
//     doc.text("Last EMI Due Report", 40, 60);

//     autoTable(doc, {
//       startY: 80,
//       head: [[
//         "Loan ID", "Loan Account No", "Member", "Centre", "Due Date",
//         "Principal", "Interest", "Total EMI", "Paid Amount", "Status"
//       ]],
//       body: filteredData.map((row) => [
//         row.loanId,
//         row.loanAccountNumber,
//         row.memberId,
//         row.groupName,
//         new Date(row.dueDate).toLocaleDateString(),
//         row.principal,
//         row.interest,
//         row.totalEmi,
//         row.paidAmount,
//         row.status,
//       ]),
//     });

//     doc.save("last_emi_due_report.pdf");
//   };

//   return (
//     <div className="emi-report-container">
//       <div className="emi-report-header">
//         <h2><i className="bi bi-file-earmark-text"></i> Last EMI Due Report</h2>

//         {/* 🔹 Filters */}
//         <div className="emi-report-filters">
//           <select
//             value={filter.status}
//             onChange={(e) => setFilter({ ...filter, status: e.target.value })}
//           >
//             <option value="">All Status</option>
//             <option value="Pending">Pending</option>
//             <option value="Paid">Paid</option>
//             <option value="Overdue">Overdue</option>
//           </select>

//           <select
//             value={filter.frequency}
//             onChange={(e) => setFilter({ ...filter, frequency: e.target.value })}
//           >
//             <option value="">All Frequency</option>
//             <option value="weekly">Weekly</option>
//             <option value="monthly">Monthly</option>
//           </select>

//           <select
//             value={filter.centre}
//             onChange={(e) => setFilter({ ...filter, centre: e.target.value })}
//           >
//             <option value="">All Centres</option>
//             {centres.map((c, idx) => (
//               <option key={idx} value={c}>{c}</option>
//             ))}
//           </select>

//           {/* 🔹 Export Buttons */}
//           <button onClick={exportCSV} className="btn-export">CSV</button>
//           <button onClick={exportExcel} className="btn-export">Excel</button>
//           <button onClick={exportPDF} className="btn-export">PDF</button>
//         </div>
//       </div>

//       {/* 🔹 EMI Due Table */}
//       {loading ? (
//         <p>Loading EMI report...</p>
//       ) : (
//         <table className="emi-report-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Loan ID</th>
//               <th>Loan Account No</th>
//               <th>Member</th>
//               <th>Centre</th>
//               <th>Due Date</th>
//               <th>Principal</th>
//               <th>Interest</th>
//               <th>Total EMI</th>
//               <th>Paid Amount</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredData.length > 0 ? (
//               filteredData.map((row, idx) => (
//                 <tr key={row.id}>
//                   <td>{idx + 1}</td>
//                   <td>{row.loanId}</td>
//                   <td>{row.loanAccountNumber}</td>
//                   <td>{row.memberId}</td>
//                   <td>{row.centrename}</td>
//                   <td>{new Date(row.dueDate).toLocaleDateString()}</td>
//                   <td>₹{row.principal}</td>
//                   <td>₹{row.interest}</td>
//                   <td>₹{row.totalEmi}</td>
//                   <td>₹{row.paidAmount}</td>
//                   <td className={
//                       row.status === "Paid" ? "status-paid"
//                       : row.status === "Pending" ? "status-pending"
//                       : "status-overdue"
//                     }>
//                     {row.status}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" className="text-center">No records found</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default EmiDueReportGroup;


// --------------------------------------------



import React, { useEffect, useMemo, useState } from "react";
import '../assets/GroupReport.css'
import { Edit, Trash } from "lucide-react";
import axios from "axios";

const GroupCreate = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const ITEMS_PER_PAGE_OPTIONS = [5, 10, 20];

  const [modalOpen, setModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  // Store only centerId here
  const [selectCenterId, setSelectedCenterId] = useState(0);

  // console.log("profile",profile)

  const [groups, setGroups] = useState([]);
  const [center, setCenter] = useState([]);

  const [formData, setFormData] = useState({
    groupName: "",
    minMember: "",
    maxMember: "",
    status: "Active",
  });

  // Input Handler
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Reset Form
  const resetForm = () => {
    setFormData({
      groupName: "",
      minMember: "",
      maxMember: "",
      status: "Active",
    });
    setSelectedCenterId(0);
    setEditIndex(null);
  };

  /* ------------------------------------
     UPDATE FUNCTION 
  ------------------------------------ */
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (editIndex === null) return;

    if (!formData.groupName || !formData.minMember || !formData.maxMember) {
      alert("Please fill required fields");
      return;
    }

    if (!selectCenterId) {
      alert("Please select a Center");
      return;
    }

 try {
      const id = groups[editIndex]?.id;

      const payload = {
      groupname: formData.groupName,
      CenterId: selectCenterId,
      Status: formData.status === "Active" ? 1 : 0,
      MinMember: Number(formData.minMember),
      MaxMember: Number(formData.maxMember),
      };

      const res = await axios.put(
        `https://payyug.in/api/groupupdate/${id}`,
        payload
      );

      alert(res.data?.message || "Updated successfully");
       fetchGroups();
      resetForm();
      setModalOpen(false);
    } catch (err) {
      alert(err.response?.data?.message || "Update failed");
    }
  };

  // handleDelete
  const handleDelete = async (id) => {
    if (!id) return alert("Invalid ID");

    if (!window.confirm("Are you sure you want to delete this group?")) return;

    try {
      const res = await axios.delete(`https://payyug.in/api/groupupdate/${id}`);
      alert(res.data?.message || "Group deleted successfully");
      fetchGroups();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to delete group");
    }
  };

  /* ------------------------------------
      GET ALL GROUPS
  ------------------------------------ */
  const fetchGroups = async () => {
    const superAdminId=localStorage.getItem("adminuserId")

    setLoading(true);
    try {
      const res = await axios.get(`https://payyug.in/api/groupupdate/getall?superAdminId=${superAdminId}&limit:100000`);
      setGroups(res.data.data);
    } catch (error) {
      alert("Failed to load groups");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  // Fetch Center Data
  const fetchCenters = async () => {
     const superAdminId=localStorage.getItem("adminuserId")
    try {
      const res = await axios.get(`https://payyug.in/api/group/centre?superAdminId=${superAdminId}&limit:100000`);
      setCenter(res.data.data);
      if (res.data.data.length > 0) {
        setSelectedCenterId(res.data.data[0].id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCenters();
  }, []);

  /* ------------------------------------
      SEARCH + PAGINATION
  ------------------------------------ */
  const filteredData = useMemo(() => {
    return groups.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [groups, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <div className="group-container">
        <h1 className="group-heading">Group Report</h1>

        <div className="group-report-filter-section">
          <div className="group-report-filter-div">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <div className="group-filter">
              <label>Show </label>
              <select
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                value={itemsPerPage}
              >
                {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
              <span> entries</span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="group-report-table-container">
          <table className="group-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Group Name</th>
                <th>Center Id</th>
                <th>Min Member</th>
                <th>Max Member</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.groupname}</td>
                    <td>{item.CenterId}</td>
                    <td>{item.MinMember}</td>
                    <td>{item.MaxMember}</td>
                    <td>{Number(item.Status) === 1 ? "Active" : "Inactive"}</td>

                    <td className="group-action-btns">
                      <Edit
                        className="edit-icon"
                        onClick={() => {
                          const globalIndex =
                            (currentPage - 1) * itemsPerPage + index;
                          setEditIndex(globalIndex);

                          setFormData({
                            groupName: item.groupname,
                            minMember: item.MinMember,
                            maxMember: item.MaxMember,
                            status:
                              Number(item.Status) === 1
                                ? "Active"
                                : "Inactive",
                          });

                          setSelectedCenterId(item.CenterId);

                          setModalOpen(true);
                        }}
                      />
                      <Trash
                        className="delete-icon"
                        onClick={() => handleDelete(item.id)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  {loading ? (
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  ) : (
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      No results found
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredData.length > itemsPerPage && (
          <div className="group-pagination-div">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ⬅ Prev
            </button>

            <span>
              Page {currentPage} of {totalPages}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next ➡
            </button>
          </div>
        )}

        {/* Modal */}
        {modalOpen && (
          <div className="group-dialog-overlay">
            <div className="group-dialog-box">
              <h2 className="group-dialog-box-heading">
                Edit Group Report
              </h2>

              <form
                className="group-dialog-box-form-section"
                onSubmit={handleUpdate}
              >
                <div className="group-dialog-box-form-grid">
                  <div className="group-dialog-box-input-group">
                    <label>Group Name</label>
                    <input
                      type="text"
                      name="groupName"
                      value={formData.groupName}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="group-dialog-box-input-group">
                    <label>Select Center</label>
                    <select
                      name="centerId"
                      value={selectCenterId}
                      onChange={(e) =>
                        setSelectedCenterId(Number(e.target.value))
                      }
                    >
                      <option value=""></option>
                      {center.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.CenterName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="group-dialog-box-input-group">
                    <label>Min Member</label>
                    <input
                      type="number"
                      name="minMember"
                      value={formData.minMember}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="group-dialog-box-input-group">
                    <label>Max Member</label>
                    <input
                      type="number"
                      name="maxMember"
                      value={formData.maxMember}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="group-dialog-box-input-group">
                    <label>Group Status</label>
                    <div>
                      <input
                        type="radio"
                        name="status"
                        value="Active"
                        checked={formData.status === "Active"}
                        onChange={handleChange}
                      />
                      ✔Active
                      <input
                        type="radio"
                        name="status"
                        value="Inactive"
                        style={{ marginLeft: "10px" }}
                        checked={formData.status === "Inactive"}
                        onChange={handleChange}
                      />
                      ❌Inactive
                    </div>
                  </div>
                </div>

                <div className="group-dialog-btns">
                  <button type="submit">
                    Update
                  </button>

                  <button type="button" onClick={() => setModalOpen(false)}>
                    Cancel
                  </button>

                  <button type="button" onClick={resetForm}>
                    Reset
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default GroupCreate;
